import { BlockConfig, zeroIOPS } from "../block-base";
import { BlockTypes } from "../block-types";

export const userConfig: BlockConfig = {
  displayName: "User",
  imagePath: "",
  isInitiator: false,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([]),
  allowedOutputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.LOAD_BALANCER,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.LAMBDA,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CDN,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: zeroIOPS(),
  processingCapacity: zeroIOPS(),
  purchasePrice: 0,
  costPerCycle: 0,
  sellPrice: 0,
  outputConnectorLimits: {
    [`${BlockTypes.APP_SERVER}`]: 3,
  },
};
